import { textStyle } from '@repay/cactus-theme';
import styled from 'styled-components';
import { colorStyle, compose, space } from 'styled-system';
import { getOmittableProps } from '../helpers/omit';
import { allText, flexItem, omitStyles } from '../helpers/styled'; // These are covered by `textStyle` instead.

var font = omitStyles(allText, 'fontSize', 'lineHeight');
var styleProps = getOmittableProps(space, colorStyle, font, flexItem, 'textStyle');
export var Text = /*#__PURE__*/styled('span').withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !styleProps.has(p);
  }
}).withConfig({
  displayName: "Text"
})(["&:not(p){margin:0;}&&&{", " ", "}"], compose(space, colorStyle, font, flexItem), function (p) {
  return p.textStyle && textStyle(p, p.textStyle);
});
export default Text;